const ES = {
    title: 'Dashboards'
};

export default ES;
